export default "__VITE_ASSET__C6Na4wWI__"